import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

const TrafficLightIndicator = ({ score, showLabel = true }) => {
  const getTrafficLight = (total) => {
    if (total >= 0 && total <= 3) return 'green';
    if (total >= 4 && total <= 8) return 'amber';
    if (total >= 9 && total <= 12) return 'red';
    return 'amber';
  };

  const light = getTrafficLight(score);

  const config = {
    green: {
      label: 'Low Sensory Impact',
      bg: 'bg-emerald-100',
      text: 'text-emerald-800',
      border: 'border-emerald-200',
      icon: CheckCircle2,
    },
    amber: {
      label: 'Moderate Sensory Impact',
      bg: 'bg-amber-100',
      text: 'text-amber-800',
      border: 'border-amber-200',
      icon: AlertTriangle,
    },
    red: {
      label: 'High Sensory Impact',
      bg: 'bg-rose-100',
      text: 'text-rose-800',
      border: 'border-rose-200',
      icon: XCircle,
    },
  };

  const { label, bg, text, border, icon: Icon } = config[light];

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border ${bg} ${text} ${border}`}
      data-testid={`traffic-light-${light}`}
    >
      <Icon className="w-4 h-4" strokeWidth={2} />
      {showLabel && <span className="text-sm font-medium">{label}</span>}
      <span className="text-xs font-semibold ml-1">({score}/12)</span>
    </div>
  );
};

export default TrafficLightIndicator;